import { lazy, Suspense, type ReactNode } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { AuthGate } from "./components/AuthGate";
import { Loading } from "./components/Ui";
import { LoginPage } from "./pages/LoginPage";

const DashboardPage = lazy(() => import("./pages/DashboardPage").then((module) => ({ default: module.DashboardPage })));
const ExpensePage = lazy(() => import("./pages/ExpensePage").then((module) => ({ default: module.ExpensePage })));
const FriendsPage = lazy(() => import("./pages/FriendsPage").then((module) => ({ default: module.FriendsPage })));
const GroupPage = lazy(() => import("./pages/GroupPage").then((module) => ({ default: module.GroupPage })));
const GroupsPage = lazy(() => import("./pages/GroupsPage").then((module) => ({ default: module.GroupsPage })));
const ImportPage = lazy(() => import("./pages/ImportPage").then((module) => ({ default: module.ImportPage })));
const NewExpensePage = lazy(() => import("./pages/NewExpensePage").then((module) => ({ default: module.NewExpensePage })));
const NotificationsPage = lazy(() => import("./pages/NotificationsPage").then((module) => ({ default: module.NotificationsPage })));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage").then((module) => ({ default: module.PrivacyPage })));
const ReceiptReviewPage = lazy(() => import("./pages/ReceiptReviewPage").then((module) => ({ default: module.ReceiptReviewPage })));
const SettingsPage = lazy(() => import("./pages/SettingsPage").then((module) => ({ default: module.SettingsPage })));

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <AuthGate />,
    children: [{
      element: <AppLayout />,
      children: [
        { path: "/", element: deferred(<DashboardPage />) },
        { path: "/friends", element: deferred(<FriendsPage />) },
        { path: "/groups", element: deferred(<GroupsPage />) },
        { path: "/groups/:groupId", element: deferred(<GroupPage />) },
        { path: "/groups/:groupId/new", element: deferred(<NewExpensePage />) },
        { path: "/groups/:groupId/expenses/:expenseId", element: deferred(<ExpensePage />) },
        { path: "/groups/:groupId/import", element: deferred(<ImportPage />) },
        { path: "/receipts/:importId/review", element: deferred(<ReceiptReviewPage />) },
        { path: "/notifications", element: deferred(<NotificationsPage />) },
        { path: "/settings", element: deferred(<SettingsPage />) },
        { path: "/privacy", element: deferred(<PrivacyPage />) },
      ],
    }],
  },
]);

function deferred(element: ReactNode) {
  return <Suspense fallback={<Loading />}>{element}</Suspense>;
}
